import * as XLSX from "xlsx";

export interface IFileCreate {
  formater: string;
  title: string;
}

export const onCreateFileExample = ({ formater, title }: IFileCreate) => {
  let data = [];

  data.push(JSON.parse(formater));


  let wb = XLSX.utils.book_new();
  let ws = (e: any) => XLSX.utils.json_to_sheet(e);
  XLSX.utils.book_append_sheet(wb, ws(data), title);
  XLSX.writeFile(wb, `${title}.xlsx`);

  return;
};
